'use strict';

angular.module('atex.dam').controller('DamEditQueryController', ['$scope',
function($scope) {

  $scope.save = function(query) {
    query.fields.forEach(function(field){
      if (field.type === 'DATE') {
        if (field.disablePatchDate === true){
          atex.dam.ViewUtils.patchDateIntervalFullRange(field.values);
        }else{
          atex.dam.ViewUtils.patchDateInterval(field.values);
        }
      }
    });
    $scope.doSave(query);
  };
  
  $scope.cancel = function() {
    $scope.doCancel();
  };
  
}]);
